// test1195
(1195 && 0);
